import { useQuery } from '@tanstack/react-query';

import { apiClient } from 'api/ApiClient';
import { useAuth } from 'shared/lib/auth/useAuth';

import type { FeaturesResponse } from './common';

export const useFeatures = (enabled = true) => {
  const { isAuthReady } = useAuth();

  return useQuery({
    queryKey: ['getFeatures'],
    queryFn: () => apiClient.getAnalyticsSource<FeaturesResponse>('features', {}),
    retry: false,
    enabled: isAuthReady,
  });
};
